import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';
import { CheckBoxesFilterCountries } from '../interfaces/check-boxes-filter-countries';

@Injectable({
  providedIn: 'root'
})
export class FiltersCheckboxService {
  public checkBoxesFilterCountries:CheckBoxesFilterCountries=null;

  filterGroup = {
    certificates: {},
    users: {}
  };

  constructor() { }

  //filtersCheckboxService
  setFilterGroupCertificate(certificates){
    this.filterGroup.certificates=certificates;
  }
  setFilterGroupUsers(users){
    this.filterGroup.users=users;
  }
  setCheckBoxesFiltersByCountryLocalStorage(data:any[]){
    localStorage.setItem('setCheckBoxesFiltersByCountry',data.join());
   }
   setCheckBoxesFiltersACRByCountryLocalStorage(arc:any[]){
    localStorage.setItem('setCheckBoxesACRFiltersByCountry',arc.join());
   }
   getCheckBoxesFiltersByCountryLocalStorage():string[]{
    let checkboxes= localStorage.getItem('setCheckBoxesFiltersByCountry');
    return ((checkboxes)==null)?[]:(checkboxes).split(',');
   }
   getCheckBoxesACRFiltersByCountryLocalStorage():string[]{
    let checkboxes= localStorage.getItem('setCheckBoxesACRFiltersByCountry');
    return  ((checkboxes)==null)?[]:(checkboxes).split(',');
   }
}
